// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__8sCzg","actionColumn":"ReferralSources_actionColumn__2brHm","textButton":"ReferralSources_textButton__10sPV"};